import { AREA_HEIGHT, AREA_WIDTH, TOOLBAR_HEIGHT } from '@static/game';
var GameConfiguratorSingleton = /** @class */ (function () {
    function GameConfiguratorSingleton() {
        var _this = this;
        this._mouse = {
            x: 10,
            y: 10,
            width: 0.1,
            height: 0.1,
        };
        this._canvas = document.getElementById('canvas-area');
        this._context = this._canvas.getContext('2d');
        this._canvas.width = AREA_WIDTH;
        this._canvas.height = AREA_HEIGHT;
        this._balance = 300;
        this._frame = 0;
        this._canvas.addEventListener('mousemove', function (event) {
            _this._mouse.x = event.x - _this.canvasPosition.left;
            _this._mouse.y = event.y - _this.canvasPosition.top;
        });
        this._canvas.addEventListener('mouseleave', function () {
            _this._mouse.x = 0;
            _this._mouse.y = 0;
        });
    }
    GameConfiguratorSingleton.getInstance = function () {
        if (!GameConfiguratorSingleton._instance) {
            GameConfiguratorSingleton._instance = new GameConfiguratorSingleton();
        }
        return GameConfiguratorSingleton._instance;
    };
    Object.defineProperty(GameConfiguratorSingleton.prototype, "canvas", {
        get: function () {
            return this._canvas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "context", {
        get: function () {
            return this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "canvasWidth", {
        get: function () {
            return this.canvas.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "canvasHeight", {
        get: function () {
            return this.canvas.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "canvasPosition", {
        get: function () {
            return this.canvas.getBoundingClientRect();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "controlsBar", {
        get: function () {
            return {
                width: this.canvas.width,
                height: TOOLBAR_HEIGHT,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "mouse", {
        get: function () {
            return this._mouse;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "balance", {
        get: function () {
            return this._balance;
        },
        set: function (value) {
            this._balance = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GameConfiguratorSingleton.prototype, "frame", {
        get: function () {
            return this._frame;
        },
        set: function (value) {
            this._frame = value;
        },
        enumerable: false,
        configurable: true
    });
    return GameConfiguratorSingleton;
}());
export { GameConfiguratorSingleton };
